import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/*
  Generated class for the Distractor page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-distractor',
  templateUrl: 'distractor.html'
})
export class DistractorPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad DistractorPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/distractor/distractor.ts